/**
 * Foundation · Durate — preferenza aziendale "Formato inserimento durate".
 * Impostazione dell'azienda (non per utente né per dipendente), solo input/visualizzazione.
 */
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DURATION_FORMAT_OPTIONS, normalizeDurationFormat } from "./durationCore";

export function DurationFormatSelect({ value, onChange, disabled = false, "data-testid": testid = "company-form-duration-format" }) {
  return (
    <div>
      <Label>Formato inserimento durate</Label>
      <Select value={normalizeDurationFormat(value)} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger data-testid={testid} aria-label="Formato inserimento durate"><SelectValue /></SelectTrigger>
        <SelectContent>
          {DURATION_FORMAT_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value} data-testid={`${testid}-option-${o.value}`}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div className="text-[11px] text-suite-neutral-500 mt-1">
        Vale per tutta l&apos;azienda. Cambia solo inserimento e visualizzazione: calcoli, esportazioni e paghe restano in ore centesimali.
      </div>
    </div>
  );
}

export default DurationFormatSelect;
